import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { add_update_dalete_training } from "../../data/ApiEndpoints";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import SelectDropdown from "../components-react/SelectDropdown";
import { trainer_receptionist_both } from "../common-data/DropdowData";

const TrainingForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    urlTitle: isEdit && rowData?.title ? rowData.title : "",
    selectedRleventFor:
      isEdit && rowData?.account_type
        ? trainer_receptionist_both.find(
            (option) => option.value === rowData.account_type
          ) ||
          trainer_receptionist_both.find((option) => option.value === "both")
        : "",
    realUrl: isEdit && rowData?.url ? rowData.url : "",
    urlDescription: isEdit && rowData?.description ? rowData.description : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setFormValues({ ...formValues, [name]: value });
  };

  function validateForm(formValues) {
    let errors = {};
    const urlPattern = /^(https:\/\/)[^\s$.?#].[^\s]*$/;

    if (!formValues.urlTitle) {
      errors.urlTitle = "Required";
    }

    if (!formValues.selectedRleventFor) {
      errors.selectedRleventFor = "Required";
    }

    if (!formValues.realUrl) {
      errors.realUrl = "Required";
    } else if (!urlPattern.test(formValues.realUrl)) {
      errors.realUrl =
        "Invalid URL. It should start with 'https://' and be a valid link.";
    }

    if (!formValues.urlDescription) {
      errors.urlDescription = "Required";
    }

    return errors;
  }

  const onSubmit = () => {
    const erros = validateForm(formValues);
    setFormErrors(erros);

    if (Object.keys(erros)?.length === 0) {
      const userData = {
        title: formValues.urlTitle || "",
        description: formValues.urlDescription || "",
        url: formValues.realUrl || "",
        account_type:
          formValues.selectedRleventFor?.value === "both"
            ? "trainer,receptionist"
            : formValues.selectedRleventFor?.value || "",
        status: formValues.isActive ? "active" : "inactive",
        uid: isEdit ? rowData?.uid || "" : "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm To Submit The Form!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = add_update_dalete_training;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add New"} URL`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="urlTitle" className={`formInputLabel `}>
              title <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter title"
              className={`formInput ${formErrors?.urlTitle ? "formError" : ""}`}
              name="urlTitle"
              value={formValues.urlTitle}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedRleventFor" className="formInputLabel">
              Who can access <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedRleventFor ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={trainer_receptionist_both}
                selectedOption={formValues.selectedRleventFor}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedRleventFor")
                }
                name="Role"
              />
            </div>
          </div>

          <div className="formInputBox span2">
            <label htmlFor="realUrl" className={`formInputLabel `}>
              URL <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter URL"
              className={`formInput ${formErrors?.realUrl ? "formError" : ""}`}
              name="realUrl"
              value={formValues.realUrl}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox span2">
            <label htmlFor="urlDescription" className="formInputLabel">
              description <span className="required">*</span>
            </label>

            <textarea
              name="urlDescription"
              className={`formInput ${
                formErrors?.urlDescription ? "formError" : ""
              }`}
              placeholder="Enter Description"
              value={formValues.urlDescription}
              onChange={onChangeInput}
            ></textarea>
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default TrainingForm;
